import { api } from "@/services/api";
import { FeedbackType } from "@/services/api/fetchers/feedback";
import { Button, Chip, CircularProgress } from "@heroui/react";
import { CaretUpIcon } from "@phosphor-icons/react";

interface FeedbackListItemProps {
  completed?: boolean;
  description: string;
  id: number;
  type: FeedbackType;
  voted?: boolean;
  votes: string[];
}

export function FeedbackListItem({ completed, description, id, type, voted, votes }: FeedbackListItemProps) {
  const color = type === "feature" ? "info" : type === "bug" ? "danger" : "warning";
  const { mutate: mutateToggleVote, isPending } = api.hooks.feedback.useToggleVote();

  const handleToggleVote = (feedbackId: number) => {
    mutateToggleVote(feedbackId);
  };

  return (
    <li className="rounded-lg bg-zinc-100 p-3 text-sm dark:bg-zinc-900/40" key={id}>
      <span>{description}</span>
      <div className="mt-4 flex items-center justify-between">
        <Chip
          classNames={{ base: color === "info" ? "bg-indigo-500/20 text-indigo-400" : undefined }}
          color={color === "info" ? undefined : color}
          size="sm"
          variant="flat"
        >
          {type}
        </Chip>
        {completed ? (
          <span className="flex items-center gap-2 text-xs font-semibold">
            <CaretUpIcon size={14} />
            {votes.length}
          </span>
        ) : (
          <Button
            className="w-auto min-w-max px-2"
            color={voted ? "success" : "default"}
            isDisabled={isPending}
            radius="sm"
            size="sm"
            variant={"bordered"}
            onPress={() => handleToggleVote(id)}
          >
            {isPending ? (
              <CircularProgress
                aria-label="Voting"
                color={voted ? "success" : "default"}
                classNames={{ svg: "h-4 w-4" }}
              />
            ) : (
              <CaretUpIcon size={16} />
            )}
            {votes.length}
          </Button>
        )}
      </div>
    </li>
  );
}
